import moment from 'moment';
import get from 'lodash/get';
import genererGuid from '@/services/general/genererGuid';
import { genererRemise } from '@/services/devis/gestionTauxNegocies';
import adresseGenerer, { getAdresseByGescomAdresse } from '@/services/general/genererAdresse';
import { CATEGORIE_DIVERS } from '@/configuration/produitConf';
import { MODE_CALCUL_MANUEL } from '@/configuration/tiers/tiersConf';
import { ANNEE } from '@/configuration/devisConf';

function genererModeCalculHonoraire() {
  return {
    modeCalcul: MODE_CALCUL_MANUEL,
    applicableSurLocation: false,
    applicableSurTlpe: false,
    applicableSurDivers: false,
    commentaire: null,
    montantForfaitHt: null,
    pourcentage: null,
    montantHonoraireForfaitaire: null,
    montantHonoraireFraisTraitement: null,
    creation: true,
  };
}


export function genererBudget() {
  return {
    dateDebut: null,
    dateFin: null,
    dateFinPremiereEcheance: null,
    prixBrutNegocie: null,
    prixNet: null,
    tlpe: 0,
    fraisTechnique: null,
    honoraires: null,
    honoraireFraisTraitement: null,
    afficherSurEdition: true,
    prixTotal: 0,
    modeCalculHonoraire: genererModeCalculHonoraire(),
    remise: genererRemise(),
    guid: genererGuid(),
    guidHorsMedia: null,
    ligneCommandeId: null,
    ligneCommandeIdHorsMedia: null,
    ligneCommandeIds: {
      location: null,
      tlpe: null,
      honoraires: null,
      fraisTechnique: null,
      honoraireFraisTraitement: null,
    },
    prixUnitaireBrut: null,
    quantiteBrut: 1,
    uniteQteBrut: ANNEE,
    prixUnitaireTlpe: 0,
    quantiteTlpe: 1,
    uniteQteTlpe: ANNEE,
  };
}

export function genererBudgetGeneration() {
  const budget = genererBudget();
  budget.dateDebut = moment().toDate();
  budget.dateFin = moment().add(1, 'year').endOf('year').toDate();
  return budget;
}

export default function genererPanneau() {
  return {
    guid: genererGuid(),
    icon: '',
    urlLogo: '',
    srcImg: '',
    heightImg: 0,
    adresse: adresseGenerer(),
    referencePanneau: '',
    regie: '',
    regieId: null,
    referenceConfrere: '',
    categorie: {},
    format: '',
    formatId: null,
    materiel: '',
    support: '',
    azimut: 0,
    commentaire: '',
    budgetGeneration: genererBudgetGeneration(),
    budgets: [],
    streetView: false,
    ancienPanneau: 'NON',
    ligneCommandeId: null,
    estPanneauSousContrat: false,
    estRenouvellement: false,
    actif: true,
    produitId: null,
    disposition: '',
    pourcentageSurface: 100,
  };
}

export function transformProduitToPanneau(produit, fournisseur) {
  const panneau = { ...genererPanneau(), id: produit.id, guid: produit.guid || produit.id };
  if (produit.categorieVente !== CATEGORIE_DIVERS) {
    panneau.regieId = get(fournisseur, 'id', null);
    panneau.srcImg = get(produit, 'srcImg', null);
    panneau.urlLogo = get(produit, 'urlLogo', null);
    panneau.azimut = get(produit, 'produitFace.azimut', 0);
    panneau.regie = get(fournisseur, 'nomCommercial', null);
    panneau.format = get(produit, 'produitFace.format', null);
    panneau.formatId = get(produit, 'produitFace.formatId', null);
    panneau.materiel = get(produit, 'produitFace.materielType', null);
    panneau.referenceConfrere = get(produit, 'referenceConfrere', '');
    panneau.disposition = get(produit, 'produitFace.disposition', null);
    panneau.adresse = getAdresseByGescomAdresse(get(produit, 'produitFace.adresse', null));
    panneau.referencePanneau = get(produit, 'reference', '');
  }
  return panneau;
}
